module.exports = __webpack_public_path__ + "static/media/database-error.b3a4a846.png";